import {useEffect,useState} from 'react'

import useCurrentUser from '../../../hooks/useCurrentUser'
import useS3DirectUpload from '../../../hooks/useS3DirectUpload'
import useApiStatusEnvAwarePost from '../../../hooks/useApiStatusEnvAwarePost'
import {envAwarePost} from '../../../util/util'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'

import {
	validateImageSize
} from '../../../util/util'

import {Link} from 'react-router-dom'

import { SketchPicker } from 'react-color'

import fontColorContrast from 'font-color-contrast'

export default function LiteIOS({setup}) {
	const statusPost = useApiStatusEnvAwarePost()

	const [isPurchased,setIsPurchased] = useState(false)

	const [buttonColor,setButtonColor] = useState('')
	const [buttonTextColor,setButtonTextColor] = useState('')

	const [darkButtonColor,setDarkButtonColor] = useState('')
	const [darkButtonTextColor,setDarkButtonTextColor] = useState('')

	const [iconUrl,setIconUrl] = useState('')
	const [newIcon,setNewIcon] = useState(null)

	const [bannerUrl,setBannerUrl] = useState('')
	const [newBanner,setNewBanner] = useState(null)

	const [status,setStatus] = useState('pending')
	useEffect(()=>{
		setStatus('pending')
		envAwarePost(
			'api/customApp/',
			{action:'getCustomLiteAppDetails'}
		).then(res=>{
			setStatus('idle')

			setIsPurchased(Boolean(res.data.is_purchased))

			setButtonColor(res.data.app_details.button_color)
			setButtonTextColor(res.data.app_details.button_text_color)

			setDarkButtonColor(res.data.app_details.dark_button_color)
			setDarkButtonTextColor(res.data.app_details.dark_button_text_color)

			setIconUrl(res.data.app_details.icon_url)
			setBannerUrl(res.data.app_details.banner_url)
		})
	},[])

	const {processUpload} = useS3DirectUpload()
	const [isSaving,setIsSaving] = useState(false)
	const handleUpdateColor = (field,value)=>{
		return statusPost('api/customApp',{
				action:'editCustomLiteAppDetails',
				update:{[field]:value}
			},'lite ios color','save')
	}

	const validSizeSuccess = async ()=>{
		setIsSaving(true)
		const iconS3Res = await processUpload(newIcon)
		const bannerS3Res = await processUpload(newBanner)
		const iconUrl = iconS3Res.payload.url
		const bannerUrl = bannerS3Res.payload.url
		statusPost('api/customApp',{
			action:'editCustomLiteAppDetails',
			update:{icon_url:iconUrl,banner_url:bannerUrl}
		},'lite ios icon','save').then(()=>{
			setIconUrl(URL.createObjectURL(newIcon))
			setBannerUrl(URL.createObjectURL(newBanner))
			setNewIcon(null)
			setNewBanner(null)
			setIsSaving(false)
		})
	}

	const handleSaveIcon = ()=>{
		validateImageSize({
			file:newIcon,
			dims:{w:512,h:512},
			success:validSizeSuccess,
			fail:(w,h)=>{
				window.alert(`Image must be exactly 512x512. The image provided was ${w}x${h}.`)
			}
		})
	}

	if(status==='pending') return (
		<div className="p-5 text-center">
			<Spinner animation="border"/>
		</div>
	)

	if(!isPurchased) return (
		<div>
			You can purchase a custom Lite iOS app with many of the features of custom app at a smaller cost. <a target="_blank" href="/upgradeCustom/">Check out our custom app offerings</a>
		</div>
	)

	return (
		<div 
			className={Boolean(setup)?"pt-2 px-2 px-md-3 pb-5":''} 
			style={{
				maxWidth:Boolean(setup)?'600px':'100%',
				margin:'auto'
			}}
		>
			{Boolean(setup)&&
				<Alert variant="success" className="text-dark">
					You're almost done setting up your Lite iOS App. Please, fill in the details below to complete your setup. 
					You can always finish setting up in the <Link to="/customization-dashboard">Customization Dashboard</Link>.
				</Alert>
			}
			<div>
				<strong>Light Mode</strong>
				<div>
					<strong>Button Color</strong>
					<div>
						This is the color of all buttons in the app.
					</div>
					<OverlayTrigger placement="bottom" trigger="click" rootClose overlay={
						<Popover>
							<SketchPicker
								color={buttonColor}
								onChangeComplete={({hex})=>{
									setButtonColor(hex)
									handleUpdateColor('button_color',hex)
								}}
							/>
						</Popover>
					}>
						<div 
							className="d-flex justify-content-center align-items-center border rounded mr-1" 
							style={{width:'100%',height:'32px',background:buttonColor}}
						>
							<span style={{color:fontColorContrast(buttonColor)}}>
								Click to edit
							</span>
						</div>
					</OverlayTrigger>
				</div>
				<div>
					<strong>Button Text Color</strong>
					<div>
						This is the color text within buttons in the app.
					</div>
					<OverlayTrigger placement="bottom" trigger="click" rootClose overlay={
						<Popover>
							<SketchPicker
								color={buttonTextColor}
								onChangeComplete={({hex})=>{
									setButtonTextColor(hex)
									handleUpdateColor('button_text_color',hex)
								}}
							/>
						</Popover>
					}>
						<div 
							className="d-flex justify-content-center align-items-center border rounded mr-1" 
							style={{width:'100%',height:'32px',background:buttonTextColor}}
						>
							<span style={{color:fontColorContrast(buttonTextColor)}}>
								Click to edit
							</span>
						</div>
					</OverlayTrigger>
				</div>
			</div>
			<hr/>
			<div>
				<strong>Dark Mode</strong>
				<div>
					<strong>Button Color</strong>
					<div>
						This is the color of all buttons in the app in dark mode.
					</div>
					<OverlayTrigger trigger="click" rootClose overlay={
						<Popover>
							<SketchPicker
								color={darkButtonColor}
								onChangeComplete={({hex})=>{
									setDarkButtonColor(hex)
									handleUpdateColor('dark_button_color',hex)
								}}
							/>
						</Popover>
					}>
						<div 
							className="d-flex justify-content-center align-items-center border rounded mr-1" 
							style={{width:'100%',height:'32px',background:darkButtonColor}}
						>
							<span style={{color:fontColorContrast(darkButtonColor)}}>
								Click to edit
							</span>
						</div>
					</OverlayTrigger>
				</div>
				<div>
					<strong>Button Text Color</strong>
					<div>
						This is the color of all text within buttons in the app in dark mode.
					</div>
					<OverlayTrigger trigger="click" rootClose overlay={
						<Popover>
							<SketchPicker
								color={darkButtonTextColor}
								onChangeComplete={({hex})=>{
									setDarkButtonTextColor(hex)
									handleUpdateColor('dark_button_text_color',hex)
								}}
							/>
						</Popover>
					}>
						<div 
							className="d-flex justify-content-center align-items-center border rounded mr-1" 
							style={{width:'100%',height:'32px',background:darkButtonTextColor}}
						>
							<span style={{color:fontColorContrast(darkButtonTextColor)}}>
								Click to edit
							</span>
						</div>
					</OverlayTrigger>
				</div>
			</div>
			<hr/>
			<div>
				<strong>Icon</strong>
				<div>This is the icon that displays on the home screen</div>
				{Boolean(iconUrl)&&
					<div>
						<img
							style={{maxHeight:'200px'}}
							className="d-block m-auto" 
							src={iconUrl}
						/>
						<Alert variant="warning" className="text-dark">
							Updating the icon is an additional cost. Please contact support@fitsw.com if you'd like to update the icon. 
						</Alert>
					</div>
				}
				{(!Boolean(iconUrl)&&!Boolean(newIcon))&&
					<div>
						<Form.File 
							onChange={e=>{
								setNewIcon(e.target.files[0])
							}}
							id="icon-image"
							label="Icon"
							custom
						/>
						<small>
							<i className="fa fa-info-circle"/> Icon must be 512x512 pixels.
						</small>
					</div>
				}
				{Boolean(newIcon)&&
					<div>
						<img
							style={{maxHeight:'200px'}}
							className="d-block m-auto" 
							src={URL.createObjectURL(newIcon)}
						/>
						<Alert variant="warning" className="text-dark">
							Please make sure this is the icon you want. Any further updates to the icon will be an additional cost. Please contact support@fitsw.com if you'd like to update the icon. 
						</Alert>
						<div className="d-flex justify-content-between">
							<Button
								disabled={isSaving}
								onClick={setNewIcon.bind(null,null)}
								variant="outline-dark"
								className="px-2"
							>
								Change Icon
							</Button>
						</div>
					</div>
				}
				<hr/>
				<strong>Banner Logo</strong>
				<div>This is a the logo your clients will see while while logged into the app.</div>
				{Boolean(bannerUrl)&&
					<div>
						<img
							style={{maxHeight:'200px'}}
							className="d-block m-auto" 
							src={bannerUrl}
						/>
						<Alert variant="warning" className="text-dark">
							Updating the banner is an additional cost. Please contact support@fitsw.com if you'd like to update the banner. 
						</Alert>
					</div>
				}
				{(!Boolean(bannerUrl)&&!Boolean(newBanner))&&
					<div>
						<Form.File 
							onChange={e=>{
								setNewBanner(e.target.files[0])
							}}
							id="icon-image"
							label="Icon"
							custom
						/>
					</div>
				}
				{Boolean(newBanner)&&
					<div>
						<img
							style={{maxHeight:'200px'}}
							className="d-block m-auto" 
							src={URL.createObjectURL(newBanner)}
						/>
						<Alert variant="warning" className="text-dark">
							Please make sure this is the banner you want. Any further updates to the banner will be an additional cost. Please contact support@fitsw.com if you'd like to update the banner. 
						</Alert>
						<div className="d-flex justify-content-between">
							<Button
								disabled={isSaving}
								onClick={setNewBanner.bind(null,null)}
								variant="outline-dark"
								className="px-2"
							>
								Change Banner
							</Button>
						</div>
					</div>
				}
				{(Boolean(newIcon)&&Boolean(newBanner))&&
					<div className="mt-2">
						<Button
							onClick={handleSaveIcon}
							disabled={isSaving}
							variant="outline-success"
							block
						>
							Save & Finish {isSaving&&<Spinner animation="border" size="sm"/>}
						</Button>
					</div>
				}
			</div>
		</div>
	)
}